import React from 'react';
import PropTypes from 'prop-types';

import { Desktop, Mobile } from '@edreamsodigeo/frontend-core';
import { Heading } from '@edreamsodigeo/prisma-design-system';

export const StepHeading = ({ children, active }) => {
  const textColor = active ? 'neutral.90' : 'neutral.70';
  return (
    <>
      <Desktop>
        <Heading type="6" weight="medium" color={textColor}>
          {children}
        </Heading>
      </Desktop>
      <Mobile>
        <Heading type="5" color={textColor}>
          {children}
        </Heading>
      </Mobile>
    </>
  );
};

StepHeading.propTypes = {
  children: PropTypes.node,
};
